import React, { useState, useContext } from 'react'
import Modal from 'components/Modal'
import CurrentProjectCard from 'components/CurrentProjectCard'
import ProjectCardContent from '../ProjectCardContent'
import { useQuery } from '@apollo/client'
import { AVAILABLE_STAFF } from 'api/staff'
import { RateCurrencyContext } from 'constants/rateCurrencyContext'
import { calcRateInCurrentCurrency } from 'services/currencies'

function ProjectCard({ projectInfo, projectIndex, onDrop }) {
  const { id, rate, rateCurrency, staffs } = projectInfo

  const { currentCurrency } = useContext(RateCurrencyContext)

  const rateInCurrentCurrency = calcRateInCurrentCurrency(
    rate,
    rateCurrency,
    currentCurrency
  )

  const [isOpenProjectCard, setIsOpenProjectCard] = useState(false)

  const { refetch } = useQuery(AVAILABLE_STAFF)

  const handleClick = () => {
    refetch()
    setIsOpenProjectCard(!isOpenProjectCard)
  }

  return (
    <>
      <ProjectCardContent
        {...projectInfo}
        rate={rateInCurrentCurrency}
        projectIndex={projectIndex}
        handleClick={handleClick}
        onDrop={onDrop}
      />
      <Modal showModal={isOpenProjectCard} closeModal={handleClick}>
        <CurrentProjectCard
          dndState={staffs}
          currentProjectId={id}
          closeModal={handleClick}
          rateForProject={rateInCurrentCurrency}
          rateCurrency={rateCurrency}
        />
      </Modal>
    </>
  )
}
export default ProjectCard
